import React from 'react'
import UserForm from '../component/UserForm'


const UserEntryForm = () => {
    return (
        <>
            <div className='entry-container'>
                <UserForm/>

            </div>
        </>
    )
}

export default UserEntryForm